import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  deleteFilter: {
    id: 'deleteFilter',
    defaultMessage: 'Delete filter',
  },
  warningDelete: {
    id: 'warningDelete',
    defaultMessage:
      'Are you sure you want to delete this filter? This action is irreversible.',
  },
  buttonDelete: {
    id: 'buttonDelete',
    defaultMessage: 'Delete',
  },
});

export default { ...globalIntl, ...m };
